import type { RouterProps } from 'wouter';
import { PersonCDDView } from 'components/pages/onboarding/PersonOnboarding';
import { PlatformOnboarding } from 'components/pages/onboarding/PlatformOnboarding';
import React, { Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';

import { DecodedParamsRoute } from './DecodedParamsRoute';

export const OnboardingRouter = ({
  hook,
  base,
  workspaceId,
}: Partial<RouterProps> & { workspaceId: string }): ReturnType<
  typeof Router
> => (
  <Suspense fallback={<>Loading...</>}>
    <Router hook={hook} base={base} key={base}>
      <Switch>
        <DecodedParamsRoute path="/">
          <PlatformOnboarding />
        </DecodedParamsRoute>
        <DecodedParamsRoute path="/person/:entityId">
          {({ entityId }) => <PersonCDDView entityId={entityId} />}
        </DecodedParamsRoute>
        <Route />
      </Switch>
    </Router>
  </Suspense>
);
